<template>
  <div class="main-agent-list" v-if="true == true">
    <el-row>
      <el-form
        :inline="true"
        :model="searchForm"
        class="demo-form-inline search-form"
        size="small"
      >
        <!--<el-form-item>
          <el-select
            v-model="searchForm.orderStatus"
            placeholder="订单类型:"
            :default-first-option="true"
          >
            <el-option
              v-for="item in orderStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>-->
        <el-form-item>
          <el-input
            v-model="searchForm.userName"
            placeholder="姓名"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="searchForm.examName"
            placeholder="考场名称"
            clearable
            v-if="searchForm.orderStatus != 1"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="searchForm.outTradeNo"
            placeholder="订单编号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-date-picker
            v-model="searchForm.date"
            type="daterange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            @click="onSearchOrder('clean')"
            icon="el-icon-search"
            >查询</el-button
          >
        </el-form-item>
        <el-form-item
            v-permission="['order:orderInfo:export']"
        >
          <el-button
            type="primary"
            @click="downloadOrder"
            icon="el-icon-download"
            >导出</el-button
          >
        </el-form-item>
      </el-form>
    </el-row>
    <el-card shadow="never" class="card-fix-height scrollable">
      <el-table
        :data="tableData"
        v-loading="loading"
        row-key="orderId"
        stripe
        show-summary
        v-if="orderStatus != 1"
        :max-height="tableHeight"
      >
        <el-table-column
          prop="outTradeNo"
          label="订单编号"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column prop="userName" label="用户姓名" show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="examName"
          label="考场名称"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column prop="agentName" label="机构" show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="tradeType"
          label="支付方式"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="totalFee"
          label="支付金额(元)"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="tradeState"
          label="支付状态"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="createDate"
          label="创建时间"
          show-overflow-tooltip
        >
        </el-table-column>
      </el-table>
      <el-table
        :data="tableData"
        v-loading="loading"
        row-key="id"
        stripe
        style="width: 100%"
        v-if="orderStatus == 1"
      >
        <el-table-column
          prop="certificateName"
          label="订单名称"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="outTradeNo"
          label="订单编号"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column prop="userName" label="用户姓名" show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="tradeState"
          label="支付状态"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="storageStatus"
          label="审核状态"
          :formatter="formatState"
          show-overflow-tooltip
        >
        </el-table-column>
      </el-table>
    </el-card>
    <el-pagination
      class="footer"
      background
      :layout="tableLayout"
      :total="tableTotal"
      :current-page="currentPage"
      :page-size.sync="pageSize"
      @current-change="onCurrentPageChange"
      align="center"
    >
    </el-pagination>
    <el-dialog :visible.sync="orderInfoVisible" title="订单详情">
      <el-row style="line-height:30px">
        <el-col :span="12">用户姓名: {{ orderInfo.userName }}</el-col>
        <el-col :span="12">联系方式: {{ orderInfo.mphone }}</el-col>
        <el-col></el-col>
      </el-row>
      <el-row style="line-height:30px">
        <el-col :span="12">订单总价: {{ orderInfo.totalFee / 100 }}¥</el-col>
        <el-col :span="12">创建时间: {{ orderInfo.createDate }}</el-col>
        <el-col>支付时间: {{ orderInfo.timeEnd }}</el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import { getOrderPager, downloadOrder } from "@/api/orderInfo";
import permission from "@/directive/permission"; // 权限判断指令
import { defaultPageConfig } from "@/config/pagination";

export default {
  name: "OrderInfo",
  directives: { permission },
  data: function() {
    return {
      searchForm: {
        userName: null,
        examName: null,
        outTradeNo: null,
        tradeState: null,
        storageStatus: null,
        orderStatus: 0,
        date: []
      },
      orderInfo: {},
      tradeStateOptions: [
        { label: "未支付", value: 1 },
        { label: "已支付", value: 2 }
      ],
      orderStatusOptions: [
        { label: "购买", value: 0 },
        { label: "激活", value: 1 }
      ],
      tableData: [],
      currentPage: 1,
      tableTotal: -1,
      tablePages: 0,
      loading: false,
      orderInfoVisible: false,
      orderStatus: 0,
      tableLayout: defaultPageConfig.layout,
      pageSize: defaultPageConfig.pageSize,
      tableHeight: 600
    };
  },
  computed: {
    dialogTitle() {
      if (this.isFormEdit) {
        return "更新用户";
      } else {
        return "新增用户";
      }
    }
  },
  created() {},
  activated() {
    let param = "";
    let income = this.$route.query.income;
    let pn = this.$route.query.examName;
    if (pn) {
      this.searchForm.examName = pn;
    }
    if (income) {
      let incomeObj = JSON.parse(income);
      param = incomeObj.param;
      let aId = incomeObj.agentId;
      let incomeParam = incomeObj.incomeParam;
      this.searchForm.param = incomeParam;
      this.searchForm.agentId = aId;
    } else {
      param = this.$route.query.param;
    }
    this.searchForm.date = [];
    if (param && param == "today") {
      let now = new Date();
      let year = now.getFullYear();
      let m = now.getMonth() + 1;
      let date = now.getDate();
      let t = year + "-" + m + "-" + date;
      this.searchForm.date.push(t);
      this.searchForm.date.push(t);
    } else if (param && param == "week") {
      let date = new Date();
      // 本周一的日期
      date.setDate(date.getDate() - date.getDay() + 1);
      let begin =
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1) +
        "-" +
        date.getDate() +
        " 00:00:00";
      date.setDate(date.getDate() + 6);
      let end =
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1) +
        "-" +
        date.getDate() +
        " 23:59:59";
      this.searchForm.date.push(begin);
      this.searchForm.date.push(end);
    } else if (param && param == "month") {
      let date = new Date();
      date.setDate(1);
      let year = date.getFullYear();
      let m = date.getMonth() + 1;
      let one = date.getDate();
      let first = year + "-" + m + "-" + one;
      let currentMonth = date.getMonth();
      let nextMonth = ++currentMonth;
      let nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
      let oneDay = 1000 * 60 * 60 * 24;
      let lastDay = new Date(nextMonthFirstDay - oneDay).getDate();
      let last = year + "-" + m + "-" + lastDay;
      this.searchForm.date.push(first);
      this.searchForm.date.push(last);
    }
    console.log(this.searchForm);
    this.loadOrderPager();
  },
  mounted() {
    let that = this;
    that.$nextTick(() => {
      that.tableHeight =
        document.getElementsByClassName("card-fix-height")[0].clientHeight - 40;
    });
  },
  methods: {
    statusFormatter(row, column, cellValue) {
      if (cellValue === 9) {
        return "已锁定";
      }
      return "正常";
    },
    onSearchOrder(val) {
      if (val) {
        this.searchForm.param = null;
        this.searchForm.agentId = null;
      }
      this.currentPage = 1;
      this.loadOrderPager();
    },
    onCurrentPageChange(page) {
      this.currentPage = page;
      this.loadOrderPager();
    },
    formatState(row, column, cellValue) {
      if (cellValue === "1") {
        return "未入库";
      } else if (cellValue === "2") {
        return "审核中";
      } else if (cellValue === "3") {
        return "已通过";
      } else if (cellValue === "4") {
        return "已过期";
      } else {
        return "已拒绝";
      }
    },
    loadOrderPager() {
      this.orderStatus = this.searchForm.orderStatus;
      let that = this;
      that.loading = true;
      let data = that._.cloneDeep(that.searchForm);
      if (data.date) {
        data.startTime = data.date[0];
        data.endTime = data.date[1];
        delete data.date;
      }
      data.page = that.currentPage;
      data.pageSize = that.pageSize;
      getOrderPager(data)
        .then(res => {
          if (res && res.code === 200) {
            that.tableTotal = Number(res.data.total);
            that.tablePages = res.data.pages;
            that.tableData = res.data.list;
            res.data.list.map(item => {
              if (item.totalFee) {
                item.totalFee = parseInt(item.totalFee) / 100;
              }
              return item;
            });
          } else {
            that.tableTotal = 0;
            that.tablePages = 0;
            that.tableData = [];
          }
        })
        .finally(() => {
          that.loading = false;
        });
    },
    downloadOrder() {
      this.orderStatus = this.searchForm.orderStatus;
      let that = this;
      let data = that._.cloneDeep(that.searchForm);
      if (data.date) {
        data.startTime = data.date[0];
        data.endTime = data.date[1];
        delete data.date;
      }
      const loading = this.$loading({
        lock: true,
        text: "正在下载",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      downloadOrder(data)
        .then(res => {
          if (!res) {
            this.$message.error("下载文件失败");
            return false;
          }
          const blob = new Blob([res.data], {
            type: "application/octet-stream"
          });
          const downloadElement = document.createElement("a");
          const href = window.URL.createObjectURL(blob);
          let contentDisposition = res.headers["content-disposition"]; //从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
          let patt = new RegExp("filename=([^;]+\\.[^\\.;]+);*");
          let result = patt.exec(contentDisposition);
          let filename = decodeURI(result[1]);
          downloadElement.style.display = "none";
          downloadElement.href = href;
          downloadElement.download = filename; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        })
        .finally(function() {
          loading.close();
        });
    },
    showOrderInfo(data) {
      this.orderInfo = data;
      this.orderInfoVisible = true;
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.main-agent-list {
  .dashboard {
    &-container {
      margin: 30px;
    }
    &-text {
      font-size: 30px;
      line-height: 46px;
    }
  }
  .el-card__body {
    overflow: hidden !important;
    .el-table--enable-row-transition {
      overflow: hidden !important;
    }
  }
  ::-webkit-scrollbar {
    background-color: #f8f8ff;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #dedfe9;
  }
  .card-fix-height {
    position: relative;
    height: calc(100vh - 50px - 53px - 15px - 40px - 51px - 52px - 2px - 30px);
  }
  .button {
    padding-bottom: 20px;
  }
}
</style>
